export default __webpack_public_path__ + "static/media/1973.a74d5dcf.png";